import {createSvgIcon} from '../create-svg-icon';

export const KeyboardDoubleArrowLeftIcon = createSvgIcon(
  [<path d="M17.59 18 19 16.59 14.42 12 19 7.41 17.59 6l-6 6z" key="0" />,<path d="m11 18 1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z" key="1" />,]
, 'KeyboardDoubleArrowLeftOutlined');
